var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-container",class:[
        {
            'wizard-container--filemanager': _vm.isFilemanagerActive,
            'wizard-container--fileeditor': _vm.isFileeditorActive
        }
    ]},[_c('app-wizard',{attrs:{"page":_vm.page}}),(_vm.isFilemanagerActive)?_c('app-filemanager'):_vm._e(),(_vm.isFileeditorActive)?_c('app-fileeditor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }